'use client'

import { Analytics } from '@a24/analytics'
import { useEffect } from 'react'

const ONETRUST_ID = process.env.NEXT_PUBLIC_ONETRUST_ID
const RUDDERSTACK_ID = process.env.NEXT_PUBLIC_RUDDERSTACK_ID
const IS_TEST_MODE = process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production'
const CONSENT_SCRIPT_AFFILIATION = 'Cherry Lane'

const AnalyticsProvider = () => {
  useEffect(() => {
    Analytics.init({
      affiliation: CONSENT_SCRIPT_AFFILIATION,
      platform: 'Web',
      config: {
        onetrust: {
          id: ONETRUST_ID,
          isTestMode: IS_TEST_MODE
        },
        rudderstack: {
          id: RUDDERSTACK_ID,
          events: {
            affiliation: CONSENT_SCRIPT_AFFILIATION
          }
        }
      }
    })
  }, [])

  return null
}

export default AnalyticsProvider
